import { AreaInfo } from '@/pages/chargermap/contract/map'
import area from './area.json'

export const AREA_LIST_NO_ALL: AreaInfo[] = area
